module.exports = __webpack_public_path__ + "static/media/iconLogoOnDark.068cd3f1.svg";